import PropTypes from "prop-types";
import { useGetAppDownloadUrl } from "@template/utils/hooks/useGetAppDownloadUrl";
import { handleDownloadApp } from "@template/helpers/handleDownloadApp";
import Button from "../Button";

const DownloadAppButton = ({
  ctaRef,
  defaultStoreUrl,
  trackingCallback,
  children,
  classes,
  theme,
  ...rest
}) => {
  const { appDownloadUrl, isLoading } = useGetAppDownloadUrl({
    ctaRef,
    defaultStoreUrl
  });

  const handleClick = e => {
    e.preventDefault();
    if (!appDownloadUrl || isLoading) return;
    handleDownloadApp({ appDownloadUrl, trackingCallback });
  };

  return (
    <Button
      onClick={handleClick}
      classes={classes}
      theme={theme}
      disabled={isLoading || !appDownloadUrl}
      {...rest}
    >
      {children}
    </Button>
  );
};

DownloadAppButton.propTypes = {
  ctaRef: PropTypes.string,
  defaultStoreUrl: PropTypes.string.isRequired,
  trackingCallback: PropTypes.func,
  children: PropTypes.node.isRequired,
  classes: PropTypes.string,
  theme: PropTypes.string
};

export default DownloadAppButton;
